export const sidebarStoreKey = 'sidebar';
